const getParam = (query: URLSearchParams | any, paramName: string) => {
  if (query instanceof URLSearchParams) {
    return query.get(paramName);
  }
  return query[paramName];
};

const parseStudioSearchPageParamsServer = (query: URLSearchParams | any) => ({
  pageNr: getParam(query, 'pageNr'),
  sortBy: getParam(query, 'sortBy'),
  query: getParam(query, 'query'),
});

export default parseStudioSearchPageParamsServer;
